import React from "react";
import { Link } from "react-router-dom";

const QuickItem = ({ to, className = "bg-wt", imgSrc, alt, title, children }) => {
  const content = (
    <div className={className}>
      {imgSrc ? (
        <img src={imgSrc} alt={alt} />
      ) : null}
      {title ? <h5>{title}</h5> : null}
      {children}
    </div>
  );

  if (to) {
    return <Link to={to}>{content}</Link>;
  }

  return content;
};

export default QuickItem;
